import React from 'react';

export function MailIcon(props: React.SVGProps<SVGSVGElement>) {
  const { className, ...rest } = props;
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 5.625C1.25 4.24429 2.36929 3.125 3.75 3.125H16.25C17.6307 3.125 18.75 4.24429 18.75 5.625V14.375C18.75 15.7557 17.6307 16.875 16.25 16.875H3.75C2.36929 16.875 1.25 15.7557 1.25 14.375V5.625ZM2.5 5.625V5.82726C2.5 6.26133 2.72519 6.66433 3.09488 6.89183L9.34488 10.738C9.74664 10.9852 10.2534 10.9852 10.6551 10.738L16.9051 6.89183C17.2748 6.66433 17.5 6.26134 17.5 5.82726V5.625C17.5 4.93464 16.9404 4.375 16.25 4.375H3.75C3.05964 4.375 2.5 4.93464 2.5 5.625ZM17.5 7.99348L11.3102 11.8026C10.5067 12.297 9.49327 12.297 8.68976 11.8026L2.5 7.99348V14.375C2.5 15.0654 3.05964 15.625 3.75 15.625H16.25C16.9404 15.625 17.5 15.0654 17.5 14.375V7.99348Z"
        fill="#5371AC"
      />
    </svg>
  );
}
